import React, { Component } from "react";
import styled from "styled-components";
import { IoMdRestaurant, IoMdWine, IoMdBus } from "react-icons/io";
import {
  FaRupeeSign,
  FaShoppingCart,
  FaGasPump,
  FaWallet,
  FaTag,
} from "react-icons/fa";
import { Bold16 } from "./common";
const Circle = styled.span`
  min-width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 7px;
  background-color: #35d0f2;
`;
const IconWrapper = styled.div`
  border: 1px solid ${(props) => props.col};
  padding: 20px;
  border-radius: 10px;
  margin-bottom: 20px;
  transition: 0.2s all;
  svg {
    color: ${(props) => props.col};
    transition: 0.2s all;
  }
`;
const Name = styled.div`
  color: #3e3e3e;
  font-weight: 400;
  font-size: 12px;
  text-align: left;
`;
const Value = styled.div`
  font-size: 12px;
  font-weight: 400;
  transition: 0.2s all;

  color: #777777;
  font-weight: 700;
  /* background: white; */
  width: 100%;
  text-align: left;
  /* padding: 6px 10px; */
  border-radius: 10px;
  /* margin-top: 4px; */
`;
const Bordered = styled.div`
  /* border: 1px solid #f0eff6; */
  margin: 8px;
  width: 108px;
  max-width: 108px;
  min-width: 108px;
 height:fit-content;
  padding: 10px 14px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  flex-grow: 1;
  flex-basis: 10%;
  background-color:#E7F9FD;
  /* &:hover {
    box-shadow: 5px 10px 18px #ddd;
    ${Value} {
      background: ${(props) => props.col};
      color: white;
    }
    ${IconWrapper} {
      background: ${(props) => props.col};
      svg {
        color: white;
      }
    }
  } */
`;

export default (props) => {
  let Icon, col;
  //
  return (
    <Bordered col={col}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          height: "fit-content",
        }}
      >
        <Name>{props.category.category}</Name>
        <div style={{ display: "flex", alignItems: "center" }}>
          {" "}
          <Circle />
          <Value>{props.category.percentage}%</Value>
        </div>
      </div>
    </Bordered>
  );
};
